/**
 * Real screenshots of the released Android app, shown by the home page.
 *
 * The files under /public/screens are captures of the released Android app with the status bar,
 * the system navigation bar and the signed-in account's name removed. Replace them with fresh
 * captures when the app's screens change, so the site never shows a flow the app no longer has.
 */
export const APP_SCREENS = {
    newRecipe: { src: '/screens/new-recipe.webp', alt: 'صفحه دستور جدید در اپ هوش‌پز: نوشتن نام مواد یا عکس گرفتن از یخچال' },
    recipeResult: { src: '/screens/recipe-result.webp', alt: 'دستور پخت ساخته‌شده در هوش‌پز با زمان پخت، تعداد نفرات، سختی و کالری تقریبی' },
    recipeDetail: { src: '/screens/recipe-detail.webp', alt: 'مواد لازم یک دستور پخت در هوش‌پز همراه با دکمه ویرایش دستور و اشتراک‌گذاری' },
    cookbook: { src: '/screens/cookbook.webp', alt: 'کتاب آشپزی هوش‌پز با جست‌وجو، دسته‌بندی و دستورهای منتخب' },
};
